// extracted by mini-css-extract-plugin
export default {"msgM":"_698940702f"};